import {
	ADD_TIME_SLOT,
	BOOKING_TIME_SLOT
} from '../actions/ActionTypes';

const initialState = {
	 timeSlot: [],
	 bookingTimeSlot: []
 };
export default function (state = initialState, action) {
	switch (action.type) {
		case ADD_TIME_SLOT:
			return {
				...state,
                timeSlot: action.data,				
			};
		case BOOKING_TIME_SLOT:
			return {
				...state,
				bookingTimeSlot: action.data,				
		};
		
		   default:
			return state;
	}
}